<template>
    <div class="main main-padding">
        <!--基础数据-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
            <!-- v-on:click="lookDataDetails()"-->
                <div class="num-card">
                    <img src="../../assets/images/schoolCount.png" class="num-card-img">
                    <div class="num-card-text">学校数: {{baseData.schoolCount}} 个</div>
                </div>
            <!-- v-on:click="lookDataDetails()"-->
                <div class="num-card-right user-num-card">
                        <div class="num-card-title">
                            <div class="num-card-title-line"></div>
                            <span>用户</span>
                        </div>
                        <div class="num-card-body">
                            <div class="num-card-body-item">
                                <div class="num-title">
                                    <img src="../../assets/images/teacherCount.png">
                                    <div class="num-card-body-num">教师数：</div>
                                </div>
                                <div class="num-card-body-count">{{baseData.teacherCount}}个</div>
                            </div>
                            <div class="num-card-body-item">
                                <div class="num-title">
                                    <img src="../../assets/images/userCount.png">
                                    <div class="num-card-body-num">学生数：</div>
                                </div>
                                <div class="num-card-body-count">{{baseData.studentCount}}个</div>
                            </div>
                        </div>
                    <!--</div>-->
                </div>
            </Col>
            <!--学校与用户数折线图-->
            <Col xs="16" :sm="16" :md="16" :lg="16" :xl="16">
                <school-user-num
                    :wisdomDataList="wisdomDataList"
                ></school-user-num>
            </Col>
            <Col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                <div class="num-card-right">
                    <div class="num-card-title">
                        <div class="num-card-title-line"></div>
                        <span>课件</span>
                    </div>
                    <div class="num-card-body">
                        <div class="num-card-body-item">
                            <div class="num-title">
                                <img src="../../assets/images/update.png">
                                <div class="num-card-body-num">上传课件：</div>
                            </div>
                            <div class="num-card-body-count">{{baseData.updateCourseware}}个</div>
                        </div>
                        <div class="num-card-body-item">
                            <div class="num-title">
                                <img src="../../assets/images/down.png">
                                <div class="num-card-body-num">下载课件：</div>
                            </div>
                            <div class="num-card-body-count">{{baseData.downCourseware}}个</div>
                        </div>
                    </div>
                </div>
                <div class="num-card-right user-num-card">
                    <div class="num-card-title">
                        <div class="num-card-title-line"></div>
                        <span>电子书</span>
                    </div>
                    <div class="num-card-body">
                        <div class="num-card-body-item">
                            <div class="num-title">
                                <img src="../../assets/images/down.png">
                                <div class="num-card-body-num">导入课本：</div>
                            </div>
                            <div class="num-card-body-count">{{baseData.downBook}}个</div>
                        </div>
                        <div class="num-card-body-item">
                            <div class="num-title">
                                <img src="../../assets/images/down.png">
                                <div class="num-card-body-num">下载资源：</div>
                            </div>
                            <div class="num-card-body-count">{{baseData.downResource}}个</div>

                        </div>
                    </div>
                </div>
            </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;">
            <!--每日新增学校数-->
            <Col xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'每日新增学校数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isIntervalDisplay=true
                    :chartsId="'yq_daily_add_school'"
                    :height="'360px'"
                    :histogramTooltip="'addSchool'"
                    ref="dailyAddSchool"
                ></histogram-charts>
            </Col>
            <!--每日新增用户数-->
            <Col xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'每日新增用户数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isIntervalDisplay=true
                    :chartsId="'yq_daily-add-user'"
                    :height="'360px'"
                    :histogramTooltip="'addUser'"
                    ref="dailyAddUser"
                ></histogram-charts>
            </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;">
            <!--主要模板使用统计-->
            <Col xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                <pie-charts
                    :chartsTitle="'主要模板使用统计'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'yq_main_scene_statics'"
                    :pieChartsName="'模板统计'"
                    ref="mainSceneStatics"
                    @click-more-data="clickMoreData"
                ></pie-charts>
            </Col>
            <Col xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="stage-select">
                    <RadioGroup v-model="subjectStage"  @on-change="changeStage(subjectStage)">
                        <Radio :label="item.value" v-for="(item,index) in stageList" :key="item.key"></Radio>
                    </RadioGroup>
                </div>
                <pie-charts
                    :chartsTitle="'学科使用统计'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'yq_subject_statics'"
                    :pieChartsName="'学科统计'"
                    ref="subjectStatics"
                ></pie-charts>
            </Col>
            <!--学校学段分布图-->
            <Col xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                <pie-charts
                    :chartsTitle="'学校学段分布图'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'yq_school_stage_distri'"
                    :pieChartsName="'学段分布'"
                    ref="schoolStageDistri"
                    @click-more-data="clickMoreData"
                ></pie-charts>
            </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;">
            <!--每日活跃学校数-->
            <Col xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <line-charts
                    :chartsTitle="'每日活跃学校数'"
                    :chartsId="'yq_daily_school'"
                    :lineCompany="'个'"
                    ref="yqDailySchool"
                ></line-charts>
            </Col>
            <!--每日活跃用户数-->
            <Col xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <line-charts
                    :chartsTitle="'每日活跃用户数'"
                    :chartsId="'yq_daily_user'"
                    :lineCompany="'人'"
                    ref="yqDailyUser"
                ></line-charts>
            </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;">
            <!-- Top10学校详情（可点击柱状图）-->
            <Col xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'Top10学校详情'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'yq_school_top'"
                    :height="'360px'"
                    :histogramTooltip="'burnPoint'"
                    ref="yqSchoolTop"
                    @click-more-data="clickMoreData"
                ></histogram-charts>
            </Col>
            <!--Top10用户详情（可点击柱状图）-->
            <Col xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <histogram-charts
                    :chartsTitle="'Top10用户详情'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'yq_user_top'"
                    :height="'360px'"
                    :histogramTooltip="'burnPoint'"
                    ref="yqUserTop"
                    @click-more-data="clickMoreData"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import SchoolUserNum from "./modules/SchoolUserNum.vue";//学校和用户总量折线图
    import HistogramCharts from "../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../components/charts/LineCharts.vue";//折线图
    import {
        findWisdomScreenUseNum, getWisdomDataNum, queryYiqiCodingKeyList,
        queryYiqiSchoolSectionMap, queryDayActive, queryYiqiUserTopTen, queryYiqiSchoolTopTen,queryYiqiCodingKeyMap,queryPieCharts
    } from "../../service/api.js";

    export default {
        name: "homework-main",
        data () {
            return {
                baseData: {
                    //基础数据
                    schoolCount: 0,//学校数量
                    userCount: 0,//用户数量
                    teacherCount: 0,//老师数量
                    studentCount: 0,//学生数量
                    downBook: 0,//下载课本数
                    downResource: 0,//下载资源数
                    updateCourseware: 0,//上传课件
                    downCourseware: 0,//下载课件
                },
                subjectStage:"小学",//学科使用统计默认学段
                subjectPhase:1,//默认为小学
                wisdomDataList: [],//学校与用户数量集合
                wisdomTopSchoolList: [],//前20学校数据集合
                wisdomTopUserList: [], //前20用户数据集合
                stageList:[
                    {
                        key:1,
                        value:'小学'
                    },
                    {
                        key:2,
                        value:'初中'
                    },
                    {
                        key:3,
                        value:'高中'
                    },
                ]
            };
        },
        components: {
            SchoolUserNum,//学校和用户总量折线图
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 切换学段
             */
            changeStage(val){
                for(let i=0;i<this.stageList.length;i++){
                    if(this.stageList[i].value===val){
                        this.subjectPhase=this.stageList[i].key;
                    }
                }
                this.getPieCharts();
            },
            /**
             *点击图表
             */
            clickMoreData (params, chartsId, productKey) {
                if (chartsId === 'yq_school_top') {
                    //点击查看Top10学校详情
                    this.$router.push({
                        name: "topUseDetails",
                        query: {
                            schoolId: this.wisdomTopSchoolList[params.dataIndex].schoolId,
                            // schoolName: this.wisdomTopSchoolList[params.dataIndex].schoolName,
                            userId: "",
                            userName: ""
                        }
                    });
                }else if (chartsId === 'yq_school_stage_distri') {
                    //点击查看学校学段分布详情
                    this.$router.push({
                        name: "wisdomClassStatic",
                        query: {
                            phase:params.data.phase
                        }
                    });
                }else if (chartsId === 'yq_main_scene_statics') {
                    //点击查看主要模板使用统计详情
                    this.$router.push({
                        name: "mainModuleDetails",
                        query: {
                            phase: 1,
                            codingKey: params.data.clsCode  //场景编码
                        }
                    });
                } else if (chartsId === 'yq_user_top') {
                    //点击查看Top10用户详情
                    this.$router.push({
                        name: "topUseDetails",
                        query: {
                            schoolId: "",
                            schoolName: "",
                            userId: this.wisdomTopUserList[params.dataIndex].userId,
                            userName: this.wisdomTopUserList[params.dataIndex].fullName
                        }
                    });
                }
            },
            /**
             * 点击跳转查看学校数据详情
             * 1：查看根据学段搜索学校；-1：查看用户列表
             */
            lookDataDetails (val) {
                this.$router.push({
                    name: "wisdomClassStatic",
                    query: {
                        phase: "0"
                    }
                });
            },
            /**
             * 获取学校数量和用户数量
             */
            async getWisdomScreenUseNum () {
                let _this = this;
                await findWisdomScreenUseNum()
                    .then(function (data) {
                        _this.baseData.schoolCount = data.schoolCount;
                        _this.baseData.userCount = data.userCount;
                        _this.baseData.teacherCount = data.teaCount;
                        _this.baseData.studentCount = data.stuCount;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取下载和下载课本资源数据
             */
            async getYiqiCodingKeyList () {
                let _this = this;
                await queryYiqiCodingKeyList()
                    .then(function (data) {
                        _this.baseData.downBook = data.downloadTextbookCount;//下载课本
                        _this.baseData.downResource = data.downloadResources;//下载资源
                        _this.baseData.updateCourseware = data.uploadCourseware;//上传课件
                        _this.baseData.downCourseware = data.downloadCourseware;//下载课件
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智慧课堂数据集合
             */
            async queryWisdomScreenUseNum () {
                let _this = this;
                await getWisdomDataNum()
                    .then(function (result) {
                        _this.wisdomDataList = result;
                        let xDataArr = [];
                        let seriesSchoolDataArr = [];
                        let seriesUserDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i <  _this.wisdomDataList.length; i++) {
                            xDataArr.push( _this.wisdomDataList[i].timeKey);
                            seriesSchoolDataArr.push( _this.wisdomDataList[i].addSchoolNumber);
                            seriesUserDataArr.push( _this.wisdomDataList[i].addUserNumber);
                        }
                        _this.$nextTick(() => {
                            //渲染每日新增学校图表
                            _this.$refs.dailyAddSchool.initDataSource( _this.wisdomDataList, xDataArr, seriesSchoolDataArr);
                            //渲染每日新增用户数图表
                            _this.$refs.dailyAddUser.initDataSource( _this.wisdomDataList, xDataArr, seriesUserDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智慧课堂学段统计饼图
             */
            async findYiqiSchoolSectionMap () {
                let _this = this;
                await queryYiqiSchoolSectionMap()
                    .then(function (result) {
                        _this.wisdomStageList = result;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i <  _this.wisdomStageList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = _this.wisdomStageList[i].count;
                            obj.name = _this.wisdomStageList[i].name;
                            obj.phase = _this.wisdomStageList[i].phase;
                            dataArr.push(obj);
                            nameArr.push(_this.wisdomStageList[i].name);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.schoolStageDistri.initDataSource( _this.wisdomStageList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取每日活跃用户与每日活跃学校数据
             */
            async findDayActive () {
                let _this = this;
                await queryDayActive()
                    .then(function (result) {
                        let wisdomDayActiveList = result;
                        let schoolDateArr = []; let schoolNumArr = [];
                        let userDateArr = []; let userNumArr = [];
                        let schoolList=[];let userList=[];
                        //处理数据以渲染图表
                        if(JSON.stringify(wisdomDayActiveList) != "{}"){
                            schoolList=wisdomDayActiveList.schoolList;
                            userList=wisdomDayActiveList.userList;
                            for (let i = 0; i < schoolList.length; i++) {
                                schoolDateArr.push(schoolList[i].date);
                                schoolNumArr.push(schoolList[i].number);
                            }
                            for (let i = 0; i < userList.length; i++) {
                                userDateArr.push(userList[i].date);
                                userNumArr.push(userList[i].number);
                            }
                        }
                        _this.$nextTick(() => {
                            //渲染每日活跃学校数
                            _this.$refs.yqDailySchool.initDataSource(schoolList, schoolDateArr, schoolNumArr);
                            //渲染每日新增用户数图表
                            _this.$refs.yqDailyUser.initDataSource(userList, userDateArr, userNumArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智慧课堂模块饼图
             */
            async getYiqiCodingKeyMap () {
                let _this = this;
                let params = {
                    phase: 1
                };
                await queryYiqiCodingKeyMap(params)
                    .then(function (data) {
                        let wisdomModuleList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < wisdomModuleList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            nameArr.push(wisdomModuleList[i].product_version);
                            obj.value = wisdomModuleList[i].userCount;
                            obj.name = wisdomModuleList[i].clsName;
                            obj.clsCode = wisdomModuleList[i].clsCode;
                            obj.type = "moduleStatics";
                            dataArr.push(obj);
                            nameArr.push(wisdomModuleList[i].clsName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mainSceneStatics.initDataSource(wisdomModuleList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取智慧课堂学科使用统计饼图
             */
            async getPieCharts () {
                let _this = this;
                let params = {
                    phase: _this.subjectPhase
                };
                await queryPieCharts(params)
                    .then(function (data) {
                        let wisdomStageDataList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < wisdomStageDataList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = wisdomStageDataList[i].count;
                            obj.name = wisdomStageDataList[i].subjectName;
                            obj.type = "stageStatics";
                            dataArr.push(obj);
                            nameArr.push(wisdomStageDataList[i].subjectName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.subjectStatics.initDataSource(wisdomStageDataList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取Top10用户详情
             */
            async findYiqiUserTopTen () {
                let _this = this;
                await queryYiqiUserTopTen()
                    .then(function (result) {
                        _this.wisdomTopUserList = result;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < _this.wisdomTopUserList.length; i++) {
                            xDataArr.push(_this.wisdomTopUserList[i].fullName);
                            seriesDataArr.push(_this.wisdomTopUserList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.yqUserTop.initDataSource(_this.wisdomTopUserList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }, /**
             * 获取 Top10学校详情（可点击柱状图）
             */
            async findYiqiSchoolTopTen () {
                let _this = this;
                await queryYiqiSchoolTopTen()
                    .then(function (result) {
                        _this.wisdomTopSchoolList = result;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        //处理数据以渲染图表
                        for (let i = 0; i < _this.wisdomTopSchoolList.length; i++) {
                            //schoolName
                            xDataArr.push(_this.wisdomTopSchoolList[i].schoolId);
                            seriesDataArr.push(_this.wisdomTopSchoolList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.yqSchoolTop.initDataSource(_this.wisdomTopSchoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },

        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "一起智慧课堂");
            //获取学校数量和用户数量
            this.getWisdomScreenUseNum();
            //获取下载和下载课本资源数据
            this.getYiqiCodingKeyList();
            //获取智慧课堂数据集合
            this.queryWisdomScreenUseNum();
            //获取智慧课堂学段统计饼图
            this.findYiqiSchoolSectionMap();
            //获取每日活跃用户与每日活跃学校数据
            this.findDayActive();
            //获取前20用户柱状图数据
            this.findYiqiUserTopTen();
            //获取前20学校柱状图数据
            this.findYiqiSchoolTopTen();
            //获取主要模板使用统计数据
            this.getYiqiCodingKeyMap();
            //获取学科使用统计数据
            this.getPieCharts();

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../style/home";

</style>
